import React, {Component} from 'react';
import {
    OverviewIcon, MlNetIcon, SciPyIcon, ScikitLearnIcon, TensorFlowIcon, PyTorchIcon,
    OrleansIcon, BeamIcon, SparkIcon, AkkaIcon, StormIcon, HeronIcon
} from '../icons/sidebarIcons';
import SearchBox from '../searchComponent/searchBox';

// Hidden for now — re-enable once auth is ready to launch (also uncomment
// the <AuthStatus/> usage below).
// import {useAuthStore} from '../../store/authStore';
//
// const AuthStatus = () => {
//     const user = useAuthStore((state) => state.user);
//     const logout = useAuthStore((state) => state.logout);
//
//     if (user) {
//         return (
//             <div className="flex items-center whitespace-nowrap ml-2">
//                 <a href="/account" className="text-sm text-blue-600 hover:text-red-700">{user.displayName}</a>
//                 <button type="button" onClick={logout}
//                         className="ml-2 text-sm text-gray-400 hover:text-red-700">Log out</button>
//             </div>
//         );
//     }
//
//     return (
//         <a href="/login" className="ml-2 text-sm whitespace-nowrap text-blue-600 hover:text-red-700">Log in</a>
//     );
// };

const DropdownItemIcon = () => (
    <svg className="mr-2 flex-none text-gray-400" width="0.9em" height="0.9em" viewBox="0 0 24 24" fill="none"
         xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

class Header extends Component {

    state = {
        currentItem: "ML.NET",
        frameworks: [
            {id: 1, title: "ML.NET", enabled: 'false', value: 'MLNET'},
            {id: 2, title: "Tensorflow", enabled: 'false', value: 'TEN'},
            {id: 3, title: "Scikit-Learn", enabled: 'false', value: 'SCI'},
            {id: 4, title: "PyTorch", enabled: 'false', value: 'PYT'}],
        language: ["English", "French", "German", "Italian", "Spanish"],
        context: 'ML.NET',
        openMenu: null
    };

    navRef = React.createRef();
    closeTimer = null;

    // Revisit this when the content is re-added
    handleChange = (event, name) => {
        const {target} = event;
        this.setState(name, target.value);
    };

    componentDidMount() {
        document.addEventListener('mousedown', this.handleDocumentClick);
        document.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleDocumentClick);
        document.removeEventListener('keydown', this.handleKeyDown);
        this.clearCloseTimer();
    }

    handleDocumentClick = (event) => {
        this.clearCloseTimer();
        if (this.navRef.current && !this.navRef.current.contains(event.target)) {
            this.closeMenu();
        }
    };

    handleKeyDown = (event) => {
        if (event.key === 'Escape') {
            this.closeMenu();
        }
    };

    clearCloseTimer = () => {
        if (this.closeTimer) {
            clearTimeout(this.closeTimer);
            this.closeTimer = null;
        }
    };

    closeMenu = () => {
        this.clearCloseTimer();
        this.setState({openMenu: null});
    };

    openMenuOn = (key) => () => {
        this.clearCloseTimer();
        this.setState({openMenu: key});
        this.closeTimer = setTimeout(this.closeMenu, 5000);
    };

    render() {

        const {openMenu} = this.state;

        return (
            <header className="border-b border-gray-100 z-10 bg-gradient-to-r from-green-500 via-gray-200 to-yellow-300 rounded-lg">
                <div className="w-full px-4 xl:container ">
                    <div className="flex flex-1 items-center h-full">
                        <a className="flex flex-none h-full margin-left:0 overflow:visible" href="/">
                            <img alt="Intelligeus Machine Learning" className="md:mr-2 h-20 w-75 flex-none "
                                 src="/images/logo-image-alternate-7.svg"/>
                        </a>
                        <button id="v2-phone-nav-button"
                                className="lg:hidden relative flex-none place-self-stretch flex items-center justify-center w-8"
                                type="button">
                            <svg className="v2-phone-nav-icon-open" xmlns="http://www.w3.org/2000/svg"
                                 aria-hidden="true" focusable="false" role="img" width="22" height="22"
                                 preserveAspectRatio="xMidYMid meet" viewBox="0 0 32 32" fill="currentColor">
                                <path d="M4 24h24v2H4z"/>
                                <path d="M4 12h24v2H4z"/>
                                <path d="M4 18h24v2H4z"/>
                                <path d="M4 6h24v2H4z"/>
                            </svg>
                            <svg className="v2-phone-nav-icon-close hidden" xmlns="http://www.w3.org/2000/svg"
                                 aria-hidden="true" focusable="false" role="img" width="1.1em" height="1.1em"
                                 preserveAspectRatio="xMidYMid meet" viewBox="0 0 32 32">
                                <path
                                    d="M24 9.4L22.6 8L16 14.6L9.4 8L8 9.4l6.6 6.6L8 22.6L9.4 24l6.6-6.6l6.6 6.6l1.4-1.4l-6.6-6.6L24 9.4z"
                                    fill="currentColor"/>
                            </svg>
                        </button>
                    </div>

                    <nav aria-label="Main" className="ml-auto " ref={this.navRef}>
                        <ul className="flex items-center space-x-2 ">
                            <li className={`v2-dropdown menu-item${openMenu === 'ml' ? ' v2-dropdown-open' : ''}`}
                                onMouseEnter={this.openMenuOn('ml')}>
                                <a href="/machine-learning" aria-haspopup="true" aria-expanded={openMenu === 'ml'}
                                   onFocus={this.openMenuOn('ml')}
                                   className="flex items-center whitespace-nowrap group px-2 py-0.5 v2-dropdown-button">

                                    <svg width="1.5em" height="1.5em" viewBox="0 0 24 24" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M4.87403 12.874L10.5858 18.5858C11.2525 19.2525 11.5858 19.5858 12 19.5858C12.4142 19.5858 12.7475 19.2525 13.4142 18.5858L19.126 12.874C19.5512 12.4488 19.7639 12.2361 19.8291 11.9597C19.8944 11.6832 19.7993 11.3979 19.6091 10.8274L18.9117 8.73509C18.4717 7.41505 18.2517 6.75503 17.7279 6.37752C17.2041 6 16.5084 6 15.117 6H8.88304C7.49159 6 6.79587 6 6.2721 6.37752C5.74832 6.75503 5.52832 7.41505 5.0883 8.73509L4.39088 10.8274C4.2007 11.3979 4.10561 11.6832 4.17087 11.9597C4.23614 12.2361 4.44877 12.4488 4.87403 12.874Z"
                                            fill="currentColor" opacity="0.25" stroke="#222222" strokeWidth="1.4"
                                            strokeLinecap="round"/>
                                    </svg>
                                    Machine Learning
                                </a>
                                <div
                                    className="absolute mt-1 min-w-full w-auto bg-gradient-to-br from-gray-50 via-orange-50 to-orange-50 dark:from-gray-950 dark:to-gray-900 rounded-xl overflow-hidden shadow-lg z-10 border border-gray-100 top-full -left-1 v2-dropdown-menu">
                                    <ul className="min-w-full w-56">
                                        <li><a className="flex items-center px-4 py-2 dropdown-menu-text dark:text-blue-400 no-underline font-normal hover:text-red-700 dark:hover:text-gray-400" href="/machine-learning"
                                               onClick={this.closeMenu}><OverviewIcon/>Overview</a></li>
                                        <li><a className="flex items-center px-4 py-2 dropdown-menu-text dark:text-blue-400 no-underline font-normal hover:text-red-700 dark:hover:text-gray-400"
                                               href="/machine-learning/tutorials/mlnet/"
                                               onClick={this.closeMenu}><MlNetIcon/>ML.NET Tutorials</a></li>
                                        <li><a className="flex items-center px-4 py-2 dropdown-menu-text dark:text-blue-400 no-underline font-normal hover:text-red-700 dark:hover:text-gray-400"
                                               href="/machine-learning/tutorials/scipy/"
                                               onClick={this.closeMenu}><SciPyIcon/>SciPy</a></li>
                                        <li><a className="flex items-center px-4 py-2 dropdown-menu-text dark:text-blue-400 no-underline font-normal hover:text-red-700 dark:hover:text-gray-400"
                                               href="/machine-learning/tutorials/scikit-learn/"
                                               onClick={this.closeMenu}><ScikitLearnIcon/>Scikit-Learn</a></li>
                                        <li><a className="flex items-center px-4 py-2 dropdown-menu-text dark:text-blue-400 no-underline font-normal hover:text-red-700 dark:hover:text-gray-400"
                                               href="/machine-learning/tutorials/tensorflow/"
                                               onClick={this.closeMenu}><TensorFlowIcon/>TensorFlow</a></li>
                                        <li><a className="flex items-center px-4 py-2 dropdown-menu-text dark:text-blue-400 no-underline font-normal hover:text-red-700 dark:hover:text-gray-400"
                                               href="/machine-learning/tutorials/pytorch/"
                                               onClick={this.closeMenu}><PyTorchIcon/>PyTorch</a></li>
                                    </ul>
                                </div>
                            </li>

                            <li className={`v2-dropdown${openMenu === 'dc' ? ' v2-dropdown-open' : ''}`}
                                onMouseEnter={this.openMenuOn('dc')}>
                                <a href="/distributed-computing" aria-haspopup="true" aria-expanded={openMenu === 'dc'}
                                   onFocus={this.openMenuOn('dc')}
                                   className="flex items-center whitespace-nowrap group px-2 py-0.5 hover:text-red-700 dark:hover:text-gray-400 v2-dropdown-button">

                                    <svg className="mr-1.5 text-gray-400 group-hover:text-indigo-500" width="1.5em"
                                         height="1.5em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M5.6 7C5.6 6.2268 6.2268 5.6 7 5.6H15C16.8778 5.6 18.4 7.12223 18.4 9V17C18.4 17.7732 17.7732 18.4 17 18.4H7C6.2268 18.4 5.6 17.7732 5.6 17V7Z"
                                            fill="currentColor" opacity="0.24" stroke="#222222" strokeWidth="1.2"/>
                                        <path d="M9 6V2" stroke="#222222" strokeWidth="1.2"/>
                                        <path d="M9 22V18" stroke="#222222" strokeWidth="1.2"/>
                                        <path d="M15 22V18" stroke="#222222" strokeWidth="1.2"/>
                                        <path d="M22 15L18 15" stroke="#222222" strokeWidth="1.2"/>
                                        <path d="M6 15L2 15" stroke="#222222" strokeWidth="1.2"/>
                                        <path d="M6 9L2 9" stroke="#222222" strokeWidth="1.2"/>
                                        <path
                                            d="M15 2.6C15.8405 2.6 16.6727 2.76554 17.4492 3.08717C18.2257 3.4088 18.9312 3.88022 19.5255 4.47452C20.1198 5.06881 20.5912 5.77434 20.9128 6.55083C21.2345 7.32731 21.4 8.15954 21.4 9"
                                            stroke="#222222" strokeWidth="1.2"/>
                                    </svg>

                                    Distributed Computing
                                </a>
                                <div
                                    className="absolute mt-1 min-w-full w-auto bg-gradient-to-br from-gray-50 via-orange-50 to-orange-50 dark:from-gray-950 dark:to-gray-900 rounded-xl overflow-hidden shadow-lg z-10 border border-gray-100 top-full -left-1 v2-dropdown-menu">
                                    <ul className="min-w-full w-56">
                                        <li><a className="flex items-center px-4 py-2 dropdown-menu-text dark:text-blue-400 no-underline font-normal hover:text-red-700 dark:hover:text-gray-400"
                                               href="/distributed-computing"
                                               onClick={this.closeMenu}><OverviewIcon/>Overview</a></li>
                                        <li><a className="flex items-center px-4 py-2 dropdown-menu-text dark:text-blue-400 no-underline font-normal hover:text-red-700 dark:hover:text-gray-400"
                                               href="/distributed-computing/microsoft-orleans/"
                                               onClick={this.closeMenu}><OrleansIcon/>Microsoft Orleans</a></li>
                                        <li><a className="flex items-center px-4 py-2 dropdown-menu-text dark:text-blue-400 no-underline font-normal hover:text-red-700 dark:hover:text-gray-400"
                                               href="/distributed-computing/microsoft-orleans/tutorials"
                                               onClick={this.closeMenu}><OrleansIcon/>Orleans Tutorials</a></li>
                                        <li><a className="flex items-center px-4 py-2 dropdown-menu-text dark:text-blue-400 no-underline font-normal hover:text-red-700 dark:hover:text-gray-400"
                                               href="/distributed-computing/apache-beam"
                                               onClick={this.closeMenu}><BeamIcon/>Apache Beam</a></li>
                                        <li><a className="flex items-center px-4 py-2 dropdown-menu-text dark:text-blue-400 no-underline font-normal hover:text-red-700 dark:hover:text-gray-400"
                                               href="/distributed-computing/apache-spark"
                                               onClick={this.closeMenu}><SparkIcon/>Apache Spark</a></li>
                                        <li><a className="flex items-center px-4 py-2 dropdown-menu-text dark:text-blue-400 no-underline font-normal hover:text-red-700 dark:hover:text-gray-400"
                                               href="/distributed-computing/akka"
                                               onClick={this.closeMenu}><AkkaIcon/>Akka</a></li>
                                        <li><a className="flex items-center px-4 py-2 dropdown-menu-text dark:text-blue-400 no-underline font-normal hover:text-red-700 dark:hover:text-gray-400"
                                               href="/distributed-computing/storm"
                                               onClick={this.closeMenu}><StormIcon/>Apache Storm</a></li>
                                        <li><a className="flex items-center px-4 py-2 dropdown-menu-text dark:text-blue-400 no-underline font-normal hover:text-red-700 dark:hover:text-gray-400"
                                               href="/distributed-computing/heron"
                                               onClick={this.closeMenu}><HeronIcon/>Apache Heron</a></li>
                                    </ul>
                                </div>
                            </li>

                            {/*<li className={`b-r v2-dropdown${openMenu === 'courses' ? ' v2-dropdown-open' : ''}`}>*/}
                            {/*    <button*/}
                            {/*        className="cursor-pointer w-full px-2 py-0.5 hover:text-gray-500 dark:hover:text-gray-400 flex items-center v2-dropdown-button"*/}
                            {/*        type="button" aria-haspopup="true" aria-expanded={openMenu === 'courses'}*/}
                            {/*        onClick={this.toggleMenu('courses')}>*/}

                            {/*        <svg className="mr-1.5 text-gray-400 w-3" width="1.5em" height="1.5em"*/}
                            {/*             viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
                            {/*            <path*/}
                            {/*                d="M9 7L6.13868 5.09245C6.0547 5.03647 5.9453 5.03647 5.86132 5.09245L3.25373 6.83084C3.12247 6.91835 3.10408 7.10408 3.21563 7.21563L5.79289 9.79289C5.9255 9.9255 6 10.1054 6 10.2929V10.2929C6 10.6834 6.31658 11 6.70711 11H17.2929C17.6834 11 18 10.6834 18 10.2929V10.2929C18 10.1054 18.0745 9.9255 18.2071 9.79289L20.7844 7.21563C20.8959 7.10408 20.8775 6.91835 20.7463 6.83084L18.1387 5.09245C18.0547 5.03647 17.9453 5.03647 17.8613 5.09245L15 7"*/}
                            {/*                stroke="#2A4157" opacity="0.24" strokeWidth="1.2"*/}
                            {/*                strokeLinecap="round"/>*/}
                            {/*            <path*/}
                            {/*                d="M6 10L7.82843 8.17157C8.40649 7.59351 8.69552 7.30448 9.06306 7.15224C9.4306 7 9.83935 7 10.6569 7H13.3431C14.1606 7 14.5694 7 14.9369 7.15224C15.3045 7.30448 15.5935 7.59351 16.1716 8.17157L18 10V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16V10Z"*/}
                            {/*                fill="currentColor" stroke="#222222" strokeWidth="1.2" opacity=".5"/>*/}
                            {/*        </svg>*/}

                            {/*        Courses*/}
                            {/*        <Chevron/>*/}
                            {/*    </button>*/}
                            {/*    <div*/}
                            {/*        className="absolute mt-1 min-w-full w-auto bg-gradient-to-br from-gray-50 via-orange-50 to-orange-50 dark:from-gray-950 dark:to-gray-900 rounded-xl overflow-hidden shadow-lg z-10 border border-gray-100 top-full -right-1 v2-dropdown-menu">*/}
                            {/*        <ul className="min-w-full w-52">*/}
                            {/*            <li><a className="flex items-center px-4 py-2 dropdown-menu-text dark:text-blue-400 no-underline font-normal hover:text-gray-500 dark:hover:text-gray-400"*/}
                            {/*                   href="/machine-learning/courses/"*/}
                            {/*                   onClick={this.closeMenu}><DropdownItemIcon/>All Courses</a></li>*/}
                            {/*        </ul>*/}
                            {/*    </div>*/}
                            {/*</li>*/}
                            <li className={`v2-dropdown${openMenu === 'llm' ? ' v2-dropdown-open' : ''}`}
                                onMouseEnter={this.openMenuOn('llm')}>
                                <a href="/llm" aria-haspopup="true" aria-expanded={openMenu === 'llm'}
                                   onFocus={this.openMenuOn('llm')}
                                   data-ga-category="header-menu" data-ga-action="clicked llm"
                                   data-ga-label="babel"
                                   className="flex items-center whitespace-nowrap group px-2 py-0.5 hover:text-red-700 dark:hover:text-gray-400 v2-dropdown-button">

                                    <svg className="mr-1.5 text-gray-400 group-hover:text-indigo-500" width="1.5em"
                                         height="1.5em" viewBox="0 0 24 24" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <rect x="4" y="4" width="7" height="7" rx="1.5" fill="currentColor" opacity="0.25" stroke="#222222" strokeWidth="1.2"/>
                                        <rect x="13" y="4" width="7" height="7" rx="1.5" fill="currentColor" opacity="0.25" stroke="#222222" strokeWidth="1.2"/>
                                        <rect x="4" y="13" width="7" height="7" rx="1.5" fill="currentColor" opacity="0.25" stroke="#222222" strokeWidth="1.2"/>
                                        <rect x="13" y="13" width="7" height="7" rx="1.5" fill="currentColor" opacity="0.25" stroke="#222222" strokeWidth="1.2"/>
                                    </svg>
                                    Large Language Models
                                </a>
                                <div
                                    className="absolute mt-1 min-w-full w-auto bg-gradient-to-br from-gray-50 via-orange-50 to-orange-50 dark:from-gray-950 dark:to-gray-900 rounded-xl overflow-hidden shadow-lg z-10 border border-gray-100 top-full -right-1 v2-dropdown-menu">
                                    <ul className="min-w-full w-52">
                                        <li><a className="flex items-center px-4 py-2 dropdown-menu-text dark:text-blue-400 no-underline font-normal hover:text-red-700 dark:hover:text-gray-400" href="/llm"
                                               data-ga-category="header-menu" data-ga-action="clicked playground"
                                               data-ga-label="babel"
                                               onClick={this.closeMenu}><DropdownItemIcon/>Large Language Models</a></li>
                                        {/*<li><a className="flex items-center px-4 py-2 dropdown-menu-text dark:text-blue-400 no-underline font-normal hover:text-red-700 dark:hover:text-gray-400" href="/examples"*/}
                                        {/*       onClick={this.closeMenu}><DropdownItemIcon/>Examples</a></li>*/}
                                    </ul>
                                </div>
                            </li>

                            <li className={`v2-dropdown${openMenu === 'playground' ? ' v2-dropdown-open' : ''}`}
                                onMouseEnter={this.openMenuOn('playground')}>
                                <a href="/playground" aria-haspopup="true" aria-expanded={openMenu === 'playground'}
                                   onFocus={this.openMenuOn('playground')}
                                   data-ga-category="header-menu" data-ga-action="clicked playground"
                                   data-ga-label="babel"
                                   className="flex items-center whitespace-nowrap group px-2 py-0.5 hover:text-red-700 dark:hover:text-gray-400 v2-dropdown-button">

                                    <svg className="mr-1.5 text-gray-400 group-hover:text-indigo-500" width="1.5em"
                                         height="1.5em" viewBox="0 0 24 24" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M10.1437 6.62759C10.9303 4.6666 11.3236 3.6861 12 3.6861C12.6763 3.6861 13.0696 4.6666 13.8562 6.6276L13.8928 6.71891C14.3372 7.82678 14.5594 8.38071 15.0123 8.7174C15.4651 9.05409 16.0596 9.10733 17.2485 9.2138L17.4634 9.23305C19.4092 9.40732 20.3822 9.49445 20.5903 10.1134C20.7985 10.7324 20.076 11.3898 18.6309 12.7044L18.1487 13.1432C17.4172 13.8087 17.0514 14.1415 16.8809 14.5776C16.8491 14.659 16.8227 14.7423 16.8018 14.8271C16.6897 15.2818 16.7968 15.7645 17.0111 16.73L17.0777 17.0305C17.4714 18.8049 17.6682 19.692 17.3246 20.0747C17.1961 20.2177 17.0292 20.3206 16.8438 20.3712C16.3476 20.5066 15.6431 19.9326 14.2342 18.7845C13.309 18.0306 12.8464 17.6537 12.3153 17.5689C12.1064 17.5355 11.8935 17.5355 11.6846 17.5689C11.1535 17.6537 10.6909 18.0306 9.76577 18.7845C8.35681 19.9326 7.65234 20.5066 7.15614 20.3712C6.97072 20.3206 6.80381 20.2177 6.67538 20.0747C6.33171 19.692 6.52854 18.8049 6.92222 17.0305L6.98889 16.73C7.2031 15.7645 7.31021 15.2818 7.19815 14.8271C7.17725 14.7423 7.15081 14.659 7.11901 14.5776C6.94854 14.1415 6.58279 13.8087 5.85128 13.1432L5.369 12.7044C3.92395 11.3898 3.20143 10.7324 3.40961 10.1134C3.61779 9.49445 4.5907 9.40732 6.53651 9.23305L6.75145 9.2138C7.94036 9.10733 8.53482 9.05409 8.98767 8.7174C9.44052 8.38071 9.66272 7.82678 10.1071 6.71891L10.1437 6.62759Z"
                                            fill="currentColor" fillOpacity="0.25" stroke="#222222" strokeWidth="1.4"/>
                                    </svg>
                                    ML Playground
                                </a>
                                <div
                                    className="absolute mt-1 min-w-full w-auto bg-gradient-to-br from-gray-50 via-orange-50 to-orange-50 dark:from-gray-950 dark:to-gray-900 rounded-xl overflow-hidden shadow-lg z-10 border border-gray-100 top-full -right-1 v2-dropdown-menu">
                                    <ul className="min-w-full w-52">
                                        <li><a className="flex items-center px-4 py-2 dropdown-menu-text dark:text-blue-400 no-underline font-normal hover:text-red-700 dark:hover:text-gray-400" href="/playground"
                                               data-ga-category="header-menu" data-ga-action="clicked playground"
                                               data-ga-label="babel"
                                               onClick={this.closeMenu}><DropdownItemIcon/>Playground</a></li>
                                        {/*<li><a className="flex items-center px-4 py-2 dropdown-menu-text dark:text-blue-400 no-underline font-normal hover:text-red-700 dark:hover:text-gray-400" href="/examples"*/}
                                        {/*       onClick={this.closeMenu}><DropdownItemIcon/>Examples</a></li>*/}
                                    </ul>
                                </div>
                            </li>

                            {/*<li>
                                <a href="/preview/hf-style"
                                   className="flex items-center whitespace-nowrap group px-2 py-0.5 hover:text-red-700 dark:hover:text-gray-400">
                                    <svg className="mr-1.5 text-gray-400 group-hover:text-indigo-500" width="1.5em"
                                         height="1.5em" viewBox="0 0 24 24" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <rect x="4" y="4" width="7" height="7" rx="1.5" fill="currentColor" opacity="0.25" stroke="#222222" strokeWidth="1.2"/>
                                        <rect x="13" y="4" width="7" height="7" rx="1.5" fill="currentColor" opacity="0.25" stroke="#222222" strokeWidth="1.2"/>
                                        <rect x="4" y="13" width="7" height="7" rx="1.5" fill="currentColor" opacity="0.25" stroke="#222222" strokeWidth="1.2"/>
                                        <rect x="13" y="13" width="7" height="7" rx="1.5" fill="currentColor" opacity="0.25" stroke="#222222" strokeWidth="1.2"/>
                                    </svg>
                                    HF Style Preview
                                </a>
                            </li>*/}

                            {/*<li>*/}

                            {/*    <a className="flex items-center group px-2 py-0.5 hover:text-red-700 dark:hover:text-gray-400"*/}
                            {/*       href="/account" data-ga-category="header-menu" data-ga-action="clicked playground"*/}
                            {/*       data-ga-label="pricing">*/}

                            {/*        <svg className="group-hover:text-indigo-500" width="2em" height="2em"*/}
                            {/*             viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
                            {/*            <circle cx="12" cy="8" r="4" fill="#222222"/>*/}
                            {/*            <path fillRule="evenodd" clipRule="evenodd"*/}
                            {/*                  d="M12 13C8.33033 13 5.32016 15.4204 5.02395 18.5004C4.99752 18.7753 5.22389 19 5.50003 19H18.5C18.7762 19 19.0025 18.7753 18.9761 18.5004C18.6799 15.4204 15.6697 13 12 13Z"*/}
                            {/*                  fill="#2A4157" fillOpacity="0.24"/>*/}
                            {/*        </svg>*/}
                            {/*        Account*/}
                            {/*    </a>*/}


                            {/*</li>*/}

                            <li className="ml-auto">
                                <SearchBox/>
                            </li>
                            {/* <li>
                                <AuthStatus/>
                            </li> */}
                        </ul>
                    </nav>

                </div>
            </header>
        )
    }

}

export default Header;
